/**
 * Clear auth-related cookies and storage to recover from corrupt state.
 * Call when user lands on login page so login can succeed.
 */
import Cookies from 'js-cookie';

export function clearForFreshLogin() {
  try {
    // Clear auth storage
    ['token', 'user', 'authToken'].forEach((key) => {
      try {
        localStorage.removeItem(key);
        sessionStorage.removeItem(key);
      } catch (e) {
        /* ignore */
      }
    });
    // Clear cookies that can cause 403 when corrupt
    Cookies.remove('csrftoken', { path: '/' });
    Cookies.remove('sessionid', { path: '/' });
    document.cookie = 'csrftoken=; Path=/; Max-Age=0';
    document.cookie = 'sessionid=; Path=/; Max-Age=0';
  } catch (e) {
    console.warn('[Auth] Error clearing for fresh login:', e?.message);
  }
}

export function persistAuthSession(token, user, { rememberMe = false } = {}) {
  if (!token || !user) return;
  const storage = rememberMe ? localStorage : sessionStorage;
  try {
    storage.setItem('token', token);
    storage.setItem('user', JSON.stringify(user));
    localStorage.setItem('lastLoginEmail', user.email || '');
  } catch (e) {
    console.warn('[Auth] Error persisting auth session:', e?.message);
  }
}
